import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

export const NotFound: React.FC = () => {
  return (
    <div className="not-found">
      <div className="container">
        <div className="not-found-content">
          <h1 className="not-found-title">404</h1>
          <h2 className="not-found-subtitle">Page Not Found</h2>
          <p className="not-found-message">
            This page doesn't exist. Either we moved it, or you typed something wrong.
            <br />
            <span className="small-text">Probably the former.</span>
          </p>
          <div className="not-found-actions">
            <Link to="/" className="btn btn-primary">
              Home
            </Link>
            <Link to="/games" className="btn btn-secondary">
              Browse Games
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};